import React from "react";

export function AppCopyright() {

    return <>
        <div className="copyright_info two">
            <div className="container">


                <div className="one_half">

                    Copyright © 2014 SISTEM X | <a href="http://studiomrak.com/" target="new">Design Studio
                    MRAK</a> | <a
                    href="https://sistemx.ba/privacy-policy">Pravila i uslovi korištenja</a>

                </div>

                <div className="one_half last">

                    <ul className="footer_social_links">
                        <li><a href="https://www.facebook.com/theSistemX?fref=ts" target="new"><i
                            className="fa fa-facebook"></i></a></li>
                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                    </ul>

                </div>

            </div>
        </div>
    </>
}